import React from 'react';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import Input from '~/components/Inputs/Input';

/**
 * Bloco "Carteiras digitais" (Google Pay / Apple Pay via Pagar.me) do
 * cadastro/edição de loja. Renderizado dentro do <Form> do Unform, logo os
 * três campos de texto entram no getData() pelo próprio name.
 *
 * - Toggles: sempre visíveis para loja Pagar.me (igual 3DS/Split).
 * - Ao ligar um toggle aparecem os campos obrigatórios da wallet (validados
 *   no backend). No Hub o acc_ vem de pagarme_hub_account_id, então o campo
 *   não é exibido.
 */
export default function WalletSettingsBlock({
  idSuffix = '',
  googlePayEnabled,
  applePayEnabled,
  onGooglePayChange,
  onApplePayChange,
  isHub = false,
}) {
  const showAccountIdField = !isHub;

  return (
    <Row className="w-100 mx-0 mb-3">
      <Col xs={12} className="px-0">
        <div className="border rounded px-3 py-3">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="pr-3">
              <div className="font-weight-700 text-gray-700">
                Carteiras digitais
              </div>
              <div className="text-muted font-size-12 mt-1">
                Exibe Google Pay e Apple Pay no checkout da loja. Pagamentos por
                carteira não passam pelo 3DS.
              </div>
            </div>

            <div className="d-flex align-items-center mt-3 mt-lg-0">
              <CustomInput
                type="switch"
                id={`googlePay${idSuffix}`}
                name="googlePay"
                label="Google Pay"
                checked={!!googlePayEnabled}
                className="text-primary mr-4"
                onChange={() => onGooglePayChange(!googlePayEnabled)}
              />
              <CustomInput
                type="switch"
                id={`applePay${idSuffix}`}
                name="applePay"
                label="Apple Pay"
                checked={!!applePayEnabled}
                className="text-primary"
                onChange={() => onApplePayChange(!applePayEnabled)}
              />
            </div>
          </div>

          {(googlePayEnabled || applePayEnabled) && (
            <>
              <div className="text-muted font-size-12 mt-3">
                Informe os dados da conta Pagar.me em que a loja transaciona. Os
                campos do Apple Pay vêm do certificado gerado para essa conta.
              </div>
              <Row className="w-100 mx-0 mt-2">
                {showAccountIdField && googlePayEnabled && (
                  <Col lg={4} className="px-0 pr-lg-2">
                    <FormGroup>
                      <Label>ID da conta Pagar.me (Google Pay)</Label>
                      <Input
                        name="pagarme_account_id"
                        placeholder="acc_xxxxxxxxxxxxxxxx"
                        type="text"
                      />
                    </FormGroup>
                  </Col>
                )}
                {applePayEnabled && (
                  <>
                    <Col lg={4} className="px-0 pr-lg-2">
                      <FormGroup>
                        <Label>Merchant ID Apple (Apple Pay)</Label>
                        <Input
                          name="apple_pay_merchant_identifier"
                          placeholder="merchant.br.com.exemplo"
                          type="text"
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={4} className="px-0">
                      <FormGroup>
                        <Label>Vencimento do certificado Apple Pay</Label>
                        <Input
                          name="apple_pay_certificate_expires_at"
                          type="date"
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
              </Row>
            </>
          )}
        </div>
      </Col>
    </Row>
  );
}
